/**
 * CPV Q7 · may this person configure report schedules at the plants in view? The server's answer (GET
 * /bp/cpv/report-schedules/access/: POLICY cpv.report_schedule.configure), read once per sign-in and location choice.
 * A person without CPV read is never asked about; a failed read hides the entry (and is asked again on the next choice).
 */
import { useEffect, useState } from 'react';
import { accessControlUtils } from '@/components/AccessControlUtils';
import { useScope } from '@/contexts/ScopeContext';
import { getScopeParams } from '@/contexts/scopeStore';
import { CPV_MODULE } from '@/menu-items/cpvMenu';
import { scheduleApi } from './scheduleApi';

const answers = new Map();   // sign-in token + location choice → Promise<boolean>

function allowedFor(key) {
  if (!answers.has(key)) {
    answers.set(key, scheduleApi.access().then((d) => d?.allowed === true).catch(() => { answers.delete(key); return false; }));
  }
  return answers.get(key);
}

export default function useReportSchedulesAllowed() {
  const { inView, version } = useScope();
  const reads = Boolean(accessControlUtils(CPV_MODULE)?.read_access);
  const key = `${localStorage.getItem('Token') || ''}|${JSON.stringify(getScopeParams())}|${inView.join(',')}|${version ?? ''}`;
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    if (!reads) { setAllowed(false); return undefined; }
    let live = true;
    allowedFor(key).then((ok) => { if (live) setAllowed(ok); });
    return () => { live = false; };
  }, [reads, key]);
  return reads && allowed;
}
